import React from 'react'

import { Redirect } from 'react-router-dom'

import * as Yup from 'yup'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../core/utils/form'

import { connect } from 'react-redux'
import { login, logout } from '../../../redux/actions/config/session'
import { getData, loadThemeFormPublic } from '../../../redux/actions/unrestricted/theme'

import '../../../assets/login/main2.css'
import Background from '../../../assets/login/fondo3.jpeg'

import { APP_VERSION, defaultSubdomian } from '../../../config/const'

const LoginSchema = Yup.object().shape({
  usuario: Yup.string().required('Username is required'),
  password: Yup.string().min(3, 'Password must be 3 characters at minimum').required('Password is required'),
  subdomain: Yup.string()
    .matches(/^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])$/, 'Enterprise has wrong format.')
    .required('Enterprise is required')
})

/**
 * Login base tomado de acá
 * https://colorlib.com/wp/template/login-form-v18/
 * prueba de formato
 */
export class Login extends React.PureComponent {
  constructor(props) {
    super(props)

    let subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false
    subdomain = subdomain === defaultSubdomian ? '' : subdomain

    this.state = {
      redirectToReferrer: false,
      initialValues: {
        usuario: '',
        password: '',
        subdomain: subdomain ? subdomain : '',
      }
    }
    window.localStorage.removeItem('roles')
    window.localStorage.removeItem('access-token')
    window.localStorage.removeItem('refresh-token')

    this.props.logout()
    this.props.loadThemeFormPublic()
  }

  _handleSubmit = (values, bag) => {
    const form = { subdomain: values.subdomain, username: values.usuario, password: values.password }
    const ret = this.props.login(form)

    ret.then((response) => {
      if (isNotValid(response)) {
        bag.setErrors(translateSymfonyErrorToFormik(response.errors.children))
        bag.setSubmitting(false)
      } else {
        if (response?.code != 401) {
          this.setState({ redirectToReferrer: true })
        } else {
          bag.setSubmitting(false)
          this.setState({ loader: false })
        }
      }
    }).catch((e) => {
      bag.setSubmitting(false)
      this.setState({ loader: false, fail: true })

      alert('Se ha producido un error desconocido')
    })
  }

  render () {
    let { from } = this.props.location?.state || { from: { pathname: '/' } }

    let { redirectToReferrer } = this.state

    if (redirectToReferrer) return <Redirect to={from} />

    return (
      <div className='limiter'>
        <div className='container-login100'>
          <div className='wrap-login100'>
            <Formik
              initialValues={this.state.initialValues}
              validationSchema={LoginSchema}
              onSubmit={this._handleSubmit}
            >
              {({ isSubmitting, touched, errors, setFieldValue }) => (
                <Form className='login100-form'>
                  <span className='login100-form-title p-b-43' style={{ paddingBottom: '43px' }}>
                    Radix
                  </span>

                  <div className='wrap-input100'>
                    <Field
                      autoComplete='off'
                      type='text'
                      name='subdomain'
                      placeholder='Enterprise'
                      disabled={this.state.initialValues.subdomain.length > 0}
                      onChange={(e) => setFieldValue('subdomain', e.target.value.trim().toLowerCase())}
                      className={`input100 ${
                          touched.subdomain && errors.subdomain ? 'is-invalid' : ''
                      }`}
                    />

                    <span className='focus-input100'>Enterprise</span>
                    <span className='label-input100' />
                  </div>
                  <ErrorMessage
                    component='div'
                    name='subdomain'
                    className='text-red invalid-feedback'
                  />

                  <div className='wrap-input100'>
                    <Field
                      data-cy='user'
                      autoComplete='off'
                      type='text'
                      name='usuario'
                      placeholder='Username'
                      className={`input100 ${
                          touched.usuario && errors.usuario ? 'is-invalid' : ''
                      }`}
                    />

                    <span className='focus-input100'>Username</span>
                    <span className='label-input100' />
                  </div>
                  <ErrorMessage
                    component='div'
                    name='usuario'
                    className='text-red invalid-feedback'
                  />

                  <div className='wrap-input100'>
                    <Field
                      data-cy='password'
                      autoComplete='off'
                      type='password'
                      name='password'
                      placeholder='Password'
                      className={`input100 ${
                          touched.password && errors.password ? 'is-invalid' : ''
                      }`}
                    />

                    <span className='focus-input100'>Password</span>
                    <span className='label-input100' />
                  </div>
                  <ErrorMessage
                    component='div'
                    name='password'
                    className='text-red invalid-feedback'
                  />

                  <div className='container-login100-form-btn'>
                    <button type='submit' className='login100-form-btn' disabled={isSubmitting}>
                      {isSubmitting ? 'One moment ...' : 'Log in'}
                    </button>
                  </div>
                  <span
                    className='login100-form-title p-b-43'
                    style={{ paddingTop: '23px', fontSize: '15px' }}
                  >
                    Version {APP_VERSION}
                  </span>
                </Form>
              )}
            </Formik>

            <div className='login100-more'>
              <img
                alt='Background'
                src={this.props.theme.login ? this.props.theme.login : Background}
                style={{ width: '100%', maxHeight: '100vh', height: '100vh' }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function MapStateToProps (state) {
  return {
    theme: getData(state),
    session: state.config.session.data
  }
}

export default connect(MapStateToProps, { login, logout, loadThemeFormPublic })(Login)
